<template>
  <div>
    <span v-for="(v, i) in rowData.items" :key="i">
      <!-- 矩阵单选题 修改 5 -->
      <div v-if="rowData.questionType === 5" class="matrix-single">
        <div v-for="(item, index) in rowData.questionDetails.issue.rows" :key="index">
          <h1 class="mini-question-description" v-if="v.rowId == item.row_id">
            <span class="___img-class" v-html="transformHtml(item.content.richText || item.content.text)"></span>
            <!-- <el-image
              v-if="getImg(item)"
              style="width: 30px; height: 30px;"
              :z-index="5000"
              :src="getImg(item)"
              :preview-src-list="[getImg(item)]"
              /> -->
          </h1>
        </div>
        <el-radio-group v-model="v.colId" size="mini" style="height: 40px; display: flex; align-items: center">
          <el-radio
            v-for="item of rowData.questionDetails.issue.items"
            :label="item.id"
            border
            :key="item.id"
            @change="updateMatrixSingle(rowData, i, item)"
            style="height: 40px; display: flex; align-items: center"
          >
            <span
              class="___img-class"
              style="min-width: 100px; display: block; white-space: normal"
              v-html="transformHtml(item.content.richText || item.content.text)"
            ></span>
            <!-- <el-image
              v-if="getImg(item)"
              style="width: 30px; height: 30px;"
              :z-index="5000"
              :src="getImg(item)"
              :preview-src-list="[getImg(item)]"
              /> -->
          </el-radio>
        </el-radio-group>
      </div>
    </span>
  </div>
</template>

<script>
import '../public/style.css'
import mixins from '../mixins'
import { itemInitOptions } from '../config/config.js'
import { getImg, saveArr } from '../public/index.js'

export default {
  mixins: [mixins],
  name: 'MatrixSingleChoice',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  mounted() {
    this.getRowData()
  },
  inject: ['transformHtml'],
  methods: {
    // app端没有答案时items为空
    getRowData() {
      let ids = []
      this.rowData.items.forEach(element => {
        ids.push(this.rowData.questionDetails.issue.rows.findIndex(item => element.rowId == item.row_id))
      })
      this.rowData.questionDetails.issue.rows.forEach((it, index) => {
        if (!ids.includes(index)) {
          this.rowData.items.push(
            Object.assign({}, itemInitOptions, {
              rowId: it.row_id,
              value: it.content.richText || it.content.text
            })
          )
        }
      })
    },
    updateMatrixSingle(row, itemsIdx, item) {
      let r_q = row.questionDetails.issue.rows[itemsIdx].content.text
      row.items[itemsIdx].colId = item.id
      row.items[itemsIdx].value = r_q + ' ' + item.content.text
      // if(this.updateArr.find(it => it.questonId === row.questionId) === undefined){
      //   this.updateArr.push(row);
      // }
      this.saveArr()
    },
    getImg,
    saveArr
  }
}
</script>

<style lang="scss">
.___img-class {
  img {
    width: 20px !important;
    height: 20px !important;
  }
}
</style>
